import { Box } from "@chakra-ui/react";
import React, { useContext, useEffect } from "react";
import { TabTitle } from "screens/common/components/TabTitle";
import { SettingsProviderContext } from "screens/panels/settings/SettingsProvider";
import { ActivityTilesSection } from "./ActivityTilesSection";

export const Activities = () => {
  const { setHeaderText } = useContext(SettingsProviderContext);

  useEffect(() => {
    setHeaderText("Activity Log");
  }, [setHeaderText]);

  return (
    <Box height={"100%"} width="100%">
      <TabTitle title="Charli > Activity History" />
      <ActivityTilesSection noItemsFoundMessage="Everything looks good, no action is required from you." />
    </Box>
  );
};
